import React from 'react';
import './CellDetailPanel.css';

function CellDetailPanel({ row, col, plants, onAddPlant, onEditPlant, onViewLogbook, onViewPlant }) {
  return (
    <section className="cell-detail-panel" aria-labelledby="cell-detail-title">
      <div className="cell-detail-panel__header">
        <h2 id="cell-detail-title" className="cell-detail-panel__title">
          Cell ({row}, {col})
        </h2>
        <button
          className="cell-detail-panel__add-btn"
          onClick={onAddPlant}
          aria-label={`Add plant to cell ${row}, ${col}`}
        >
          Add Plant
        </button>
      </div>

      {plants.length === 0 ? (
        <p className="cell-detail-panel__empty">No plants in this cell</p>
      ) : (
        <ul className="cell-detail-panel__list" aria-label="Plants in this cell">
          {plants.map((plant) => (
            <li
              key={plant.id}
              className="cell-detail-panel__plant-item"
              draggable="true"
              onDragStart={(e) => {
                e.dataTransfer.setData('text/plant-id', plant.id);
                e.dataTransfer.effectAllowed = 'move';
              }}
            >
              <div className="cell-detail-panel__plant-info">
                <span className="cell-detail-panel__drag-handle" aria-hidden="true">⠿</span>
                <div>
                  <p className="cell-detail-panel__plant-common-name">
                    {plant.commonName}
                  </p>
                  <p className="cell-detail-panel__plant-scientific-name">
                    {plant.scientificName}
                  </p>
                  {plant.trayNumber && (
                    <p className="cell-detail-panel__plant-tray">
                      Tray: {plant.trayNumber}
                    </p>
                  )}
                  <p className="cell-detail-panel__plant-counts">
                    {[
                      plant.qtyPlugs > 0 && `${plant.qtyPlugs} plugs`,
                      plant.qtySoloCups > 0 && `${plant.qtySoloCups} solo`,
                      plant.qtyQuarts > 0 && `${plant.qtyQuarts} qt`,
                      plant.qtyGallons > 0 && `${plant.qtyGallons} gal`,
                    ].filter(Boolean).join(' · ') || 'No quantities'}
                  </p>
                </div>
              </div>
              <div className="cell-detail-panel__plant-actions">
                <button
                  className="cell-detail-panel__action-btn cell-detail-panel__action-btn--primary"
                  onClick={() => onViewPlant(plant.id)}
                  aria-label={`View ${plant.commonName}`}
                >
                  View
                </button>
                <button
                  className="cell-detail-panel__action-btn"
                  onClick={() => onEditPlant(plant.id)}
                  aria-label={`Edit ${plant.commonName}`}
                >
                  Edit
                </button>
                <button
                  className="cell-detail-panel__action-btn"
                  onClick={() => onViewLogbook(plant.id)}
                  aria-label={`View logbook for ${plant.commonName}`}
                >
                  Logbook
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default CellDetailPanel;
